import { TIME_START, TIMEOUT_ID, SIGN_INFO, LOGIN_USER, SIGN_OUT_USER, SET_TYPE, SET_PAGE } from '../actions/constants'
import { loadSession } from '../../api'

// KEEP THE USER LOGGED IN AFTER A PAGE RELOAD (THE BACKEND STILL CHECKS THE TOKEN)
const session = loadSession()

const initialState = {
    timeStart: new Date(),
    timeoutId: null,
    authenticated: !!session?.token,
    signInformation: session?.token ? { token: session.token } : {},
    currentUser: session?.user || {}
};

const authReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case TIME_START:
            return {
                ...state,
                timeStart: payload,
            }
        case TIMEOUT_ID:
            return {
                ...state,
                timeoutId: payload,
            }
        case SIGN_INFO:
            return {
                ...state,
                authenticated: true,
                signInformation: payload
            }
        case LOGIN_USER:
            return {
                ...state,
                authenticated: true,
                currentUser: payload
            }
        case SIGN_OUT_USER:
            return {
                ...state,
                authenticated: false,
                signInformation: {},
                currentUser: {}
            }
        default:
            return state;
    }
}

export default authReducer